import { CheckCircleOutline, NotInterestedOutlined } from '@mui/icons-material';
import { Stack, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface PreferenceStatusProps {
    enabled: boolean;
}

export default function PreferenceStatus({ enabled }: PreferenceStatusProps) {
    const { t } = useTranslation('profile');

    return (
        <Root enabled={ enabled }>
            { enabled
                ? <><CheckCircleOutline />{ t('view.status.enabled') }</>
                : <><NotInterestedOutlined />{ t('view.status.disabled') }</> }
        </Root>
    );
}

const Root = styled(Stack, {
    shouldForwardProp: prop => prop !== 'enabled'
})<{ enabled: boolean }>(({ theme, enabled }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: enabled ? theme.palette.success.dark : theme.palette.error.main,

    svg: {
        fontSize: 'medium',
        color: 'inherit'
    }
}));
